export { childrenShippingsPageBreadcrumbs } from './breadcrumbs';
export { shippingsTableColumns } from './columns';
export {
  getShippingDetailsFirstTableColumns,
  getShippingDetailsSecondTableColumns,
  shippingProductsColumns,
} from './shippingDetailsColumns';
export const MAX_SHIPPINGS_ON_MAP = 300;
export const MAX_ROUTE_POINTS = 180;

export const ROUTE_BUILDER_ROUTING_ZONES_PAGE_SIZE = 1000;
export const ROUTE_BUILDER_ROUTING_ZONE_TYPES_PAGE_SIZE = 500;

export {
  DEFAULT_STATUS_ID,
  DEFAULT_SIZE_ID,
  DEFAULT_COMPLEXITY_ID,
  DEFAULT_CHANNEL_ID,
  COUNTRY_ID,
  DEFAULT_LOGISTIC_OPERATOR_ID,
} from './defaults';